import React, { useState, useEffect } from "react";
import axios from "axios";
import Toast from "../../components/Toast/Toast.jsx";
import ContactUsForm from "./Components/ContactUsForm";
import IMG from "../../assets/4.png";
import CONTACTUS from "../../assets/contact-us.png";
import toast from "react-hot-toast";

const ContactUs = ({ content }) => {
  const [captchaValue, setCaptchaValue] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    if (process.env.REACT_APP_RECAPTCHA_ENABLER === "true") {
      // First check if captcha value is empty
      if (!captchaValue) {
        toast.error("Please complete the reCAPTCHA verification.");
        return;
      }
      else if (! await verifiyCaptcha(captchaValue)) {
        toast.error("Please verify reCAPTCHA");
        return;
      }
    }
    setIsLoading(true);

    let payload = {
      ...values,
    };

    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("email", payload.email);
    formData.append("phone_number", payload.phone_number);
    formData.append("message", payload.message);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}service/contact-us/`,
        formData
      );
      if (response.data.error) {
        toast.error("Error!");
        return;
      }
      toast.success("Message Sent");
      setIsFormSubmitted(true);
    } catch (error) {
      toast.error("Unable to send you message, please try again later", {
        id: "send-message",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  async function verifiyCaptcha(captchaToken)
  {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}recaptcha-token/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ recaptchaToken: captchaToken }),
        }
      );
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error("Error verifying captcha:", error);
      return false;
    }
  }

  return (
    <>
      <style jsx="true">{`
        ::-webkit-scrollbar {
          width: 5px;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 50px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: #555;
          border-radius: 50px;
        }

        .contact-us-back {
          background-image: url(${IMG});
          background-size: cover;
          background-position: center;
          height: 100%;

          .contact-us-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding-top: 4rem;

            .contact-us-heading {
              color: #68755c;
              font-weight: bold;
              margin-bottom: 5px;
            }

            .contact-us-line {
              width: 5%;
            }

            .contact-us-para {
              font-size: 1vw;
              font-weight: 500;
            }

            .contact-us-form {
              width: 88%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 50px;

              .submitted-text {
                color: #869672;
                font-size: 1.6vw;
                font-weight: bold;
              }

              .contact-us-image-class {
                .contact-us-img {
                  width: 80%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }

            @media screen and (max-width: 768px) {
              .contact-us-para {
                font-size: 3vw;
                margin-bottom: 30px;
              }

              .contact-us-line {
                width: 10%;
              }

              .contact-us-form {
                width: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 50px;

                .submitted-text {
                  font-size: 5vw;
                  margin-bottom: 25px;
                }

                .contact-us-image-class {
                  .contact-us-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }
              }
            }
          }
        }
      `}</style>

      <div className="contact-us-back">
        <div className="container">
          <div className="contact-us-content">
            <h1 className="contact-us-heading">{content[0].description}</h1>
            <hr className="contact-us-line" />
            <p className="contact-us-para col-md-10">
              {content[1].description}
            </p>
            <div className="contact-us-form">
              {!isFormSubmitted ? (
                <ContactUsForm
                  setCaptchaValue={setCaptchaValue}
                  onSubmit={onSubmit}
                  isLoading={isLoading}
                  content={content[3].description}
                />
              ) : (
                <div className="submitted-text">{content[2].description}</div>
              )}
              <p className="contact-us-image-class col-md-6">
                <img src={CONTACTUS} alt="" className="contact-us-img" />
              </p>
            </div>
          </div>
        </div>
      </div>
      <Toast />
    </>
  );
};

export default ContactUs;
